import { gql } from '@apollo/client';

export const GET_USER_WALLETS = gql`
  query UserWallets {
    userWallets {
      id
      userId
      address
      label
      createdAt
      updatedAt
    }
  }
`;


